import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from '@/components/ui/spinner';

export function PipelineLoading(): ReactNode {
  return (
    <div className="flex justify-center py-3xl">
      <Spinner />
    </div>
  );
}

type GuardInput = {
  isLoading: boolean;
  isCollector: boolean;
  enabled: boolean;
  isAdmin: boolean;
};

export function shouldRedirect(p: GuardInput): 'loading' | 'redirect' | null {
  if (p.isLoading) return 'loading';
  if (p.isCollector) return 'redirect';
  if (!p.enabled && !p.isAdmin) return 'redirect';
  return null;
}

export function PipelineRedirect(): ReactNode {
  return <Navigate to="/creators" replace />;
}
